import { render } from "./LocationSchemaJson.vue?vue&type=template&id=5e129145"
import script from "./LocationSchemaJson.vue?vue&type=script&lang=js"
export * from "./LocationSchemaJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__